export enum StripeStatus {
  ACTIVE = 'active',
  INCOMPLETE = 'incomplete',
  TRIALING = 'trialing',
  PAST_DUE = 'past_due',
  CANCELED = 'canceled',
  UNPAID = 'unpaid',
  PAUSED = 'paused'
}
